<template>
  <div class="container container-row padded">
    <wrap-container class="relative-container cascade w50 consult-left">
      <wrap-container>
        <h1
          id="titulo"
          class="titulo p32 medium oscuro"
          v-safe-html="config.pasos.consulta.titulo"
        >
          {{ config.pasos.consulta.titulo }}
        </h1>
        <h2
          id="subtitulo"
          class="titulo oscuro"
          v-safe-html="config.pasos.consulta.subtitulo"
        >
          {{ config.pasos.consulta.subtitulo }}
        </h2>
      </wrap-container>
      <form-validator>
        <wrap-container class="grid-container grid-container--6-6">
          <text-input
            class="col1"
            label="Nombres"
            hint="Ingresá tus nombres"
            name="nombre"
            v-model="model.nombre"
            :maxlengthError="20"
            :required="true"
            pattern="(^[A-Za-z ']{1,20})$"
            @click="trackClick('nombre')"
            @onFocus="trackClick('nombre')"
            quantumObfuscate
          />
          <text-input
            class="col2"
            label="Apellidos"
            hint="Ingresá tus apellidos"
            name="apellido"
            v-model="model.apellido"
            :maxlengthError="55"
            :required="true"
            pattern="(^[A-Za-z ']{1,55})$"
            @click="trackClick('apellido')"
            @onFocus="trackClick('apellido')"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container class="grid-container grid-container--6-6">
          <custom-input-group
            class="col1"
            :value="model.sexo"
            v-model="model.sexo"
            name="sexo"
            :required="true"
            @click="trackClick('sexo')"
            @onFocus="trackClick('sexo')"
          >
            <radio-item
              optionValue="F"
              label="Femenino"
              smallLabel="F"
              name="sexo"
              quantumObfuscate
            />
            <radio-item
              optionValue="M"
              label="Masculino"
              smallLabel="M"
              name="sexo"
              quantumObfuscate
            />
          </custom-input-group>
          <wrap-container class="col2">
            <dni-input
              label="Número de documento"
              hint="Ej: 28956372"
              v-model="model.numeroDoc"
              :required="true"
              maxlength="8"
              @click="trackClick('dni')"
              @onFocus="trackClick('dni')"
              inputName="numeroDoc"
              :tipoDoc.sync="model.tipoDoc"
              quantumObfuscate
            />
          </wrap-container>
        </wrap-container>
        <wrap-container v-show="model.tipoDoc === tiposDocumentos.DNE">
          <section-label value="Indicanos tu tipo de residencia:" />
          <residence-type
            v-model="model.tipoResidencia"
            name="tipoResidencia"
            :required="model.tipoDoc === tiposDocumentos.DNE"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container
          class="double-width grid-container--6-6"
          v-show="model.tipoDoc === tiposDocumentos.DNE"
        >
          <country-selector
            :esExtranjero="model.tipoDoc === tiposDocumentos.DNE"
            class="col1"
            v-model="model.nacionalidad"
            name="nacionalidad"
            @click="trackClick('nacionalidad')"
            @onFocus="trackClick('nacionalidad')"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container>
          <wrap-container class="grid-container grid-container--6-6">
            <date-field
              class="email-date col1"
              v-model="model.fechaNacimiento"
              subhint="Ejemplo: 18/07/1985"
              name="fechaNacimiento"
              :required="true"
              :minAge="18"
              :maxAge="100"
              @click="trackClick('fechaNacimiento')"
              @onFocus="trackClick('fechaNacimiento')"
              :compatible="validarNumeroDocFechaNacimiento"
              :debeSerMayor="true"
              quantumObfuscate
            />
            <email-field
              class="email-date col2"
              v-model="model.email"
              name="email"
              :required="true"
              @click="trackClick('email')"
              @onFocus="trackClick('email')"
              quantumObfuscate
            />
          </wrap-container>
        </wrap-container>
        <wrap-container>
          <wrap-container class="grid-container grid-container--6-6">
            <wrap-container class="col1">
              <phone-number
                class="col1"
                v-model="model.celular"
                :required="true"
                name="celular"
                quantumObfuscate
              />
            </wrap-container>
          </wrap-container>
        </wrap-container>
        <wrap-container>
          <div class="terms-wrapper container">
            <p>
              Al presionar continuar acepto los
              <custom-link
                v-if="responsiveTerms"
                class="custom-link"
                label="términos y condiciones"
                @click.native="showModal = true"
              />
              <custom-link
                v-if="!responsiveTerms"
                class="custom-link"
                label="términos y condiciones"
                @click.native="openTerms()"
              />
              sobre el tratamiento de los datos.
            </p>
          </div>
          <terms-conditions :show="showModal" @close="showModal = false" />
        </wrap-container>
        <wrap-container v-if="!isProduction"></wrap-container>
        <sales-button
          :color="color"
          ref="salesbutton"
          id="conocerOferta"
          @click="probar"
          label="Conocer oferta"
          analyticsName="conocer oferta"
        />
      </form-validator>
    </wrap-container>
    <wrap-container
      class="relative-container cascade w50 padding-17-left-right consult-right"
    >
      <img
        class="img-consulta"
        src="../assets/img/ofertaNomina/cajaDeAhorro/LogotipoOpenpay_RGB-01 1.svg"
        alt="Logo OpenPay"
      />
    </wrap-container>
    <wrap-container class="recaptcha-holder w50" style="text-align: center">
      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        @render="onCaptchaRendered"
        size="invisible"
        badge="inline"
        sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
      >
      </vue-recaptcha>
    </wrap-container>
  </div>
</template>

<script>
import { tiposDocumentos } from "@/config/constants";
import WrapContainer from "@/components/core/Container";
import CountrySelector from "@/components/core/composite/combos/CountrySelector";
import FormValidator from "@/components/core/FormValidator";
import TextInput from "@/components/core/TextInput";
import VueRecaptcha from "vue-recaptcha";
import EmailField from "@/components/core/EmailField";
import DateField from "@/components/core/DateField";
import CustomLink from "@/components/core/CustomLink";
import SalesButton from "@/components/core/SalesButton";
import DniInput from "@/components/core/composite/DniInput";
import SectionLabel from "@/components/core/SectionLabel";
import ResidenceType from "@/components/core/custom/ResidenceType";
import CustomInputGroup from "@/components/core/custom/CustomInputGroup";
import RadioItem from "@/components/core/custom/RadioItem";
import PhoneNumber from "@/components/core/composite/PhoneNumber";
import * as ACTIONS from "@/config/constants/action-types";
import TermsConditions from "@/components/core/modals/TermsConditions";
import { RECHAZADO } from "@/config/constants/step-constants";
import consultaBaseMixin from "@/mixins/consulta-base";

export default {
  name: "ConsultaEmprendedores",
  mixins: [consultaBaseMixin],
  data() {
    return {
      showModal: false,
      terms: require(`@/assets/pdf/${_BBVA_MOTOR}/terms.pdf`),
      color: "#1973B8"
    };
  },
  computed: {
    responsiveTerms() {
      return this.$mq.small ? true : false;
    }
  },
  methods: {
    modalToggle() {
      this.showModal = !this.showModal;
    },
    probar() {
      if (!PRODUCTION) {
        // Omitimos el captcha
        return this.onCaptchaVerified("fakeToken123");
      }
      if (
        this.model.tipoResidencia === "temporal" &&
        this.model.tipoDoc == tiposDocumentos.DNE
      ) {
        this.$router.push({ name: "mensaje", params: { mje: RECHAZADO } });
      } else {
        if (this.recaptchaLoaded) {
          // Recaptcha cargó correctamente? --> ejecutar
          this.$store.dispatch(ACTIONS.DO_IS_LOADING, true);
          this.$refs.recaptcha.execute();
        } else {
          // No se pudo cargar recaptcha y no puede validarse
          // Redirigir a error técnico?
          this.$log.error("No se pudo cargar recaptcha");
        }
      }
    },
    openTerms() {
      window.open(this.terms);
    }
  },
  components: {
    TextInput,
    EmailField,
    FormValidator,
    WrapContainer,
    DateField,
    CustomLink,
    SalesButton,
    DniInput,
    SectionLabel,
    ResidenceType,
    CustomInputGroup,
    RadioItem,
    VueRecaptcha,
    CountrySelector,
    TermsConditions,
    PhoneNumber
  }
};
</script>
<style scoped>
.container-row {
  max-width: 1200px;
  margin: 0 auto;
}

.img-consulta {
  margin-top: 160px;
  width: 70%;
}

.terms-wrapper p {
  line-height: 2px;
  font-size: 15px;
  margin-top: 20px;
}

div.recaptcha-holder {
  margin-top: 24px;
  opacity: 0.3;
}

#subtitulo {
  margin-bottom: 40px;
  font-size: 16px;
}

#titulo {
  margin-bottom: 16px;
}

.double-width {
  margin-bottom: 32px;
}

.genero-sub {
  margin-top: -10px;
  margin-bottom: 25px;
}

.email-date {
  margin-top: -20px;
  margin-bottom: 26px;
}

@media screen and (max-width: 1024px) {
  .consult-right {
    display: none;
  }

  .consult-left {
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
  }

  .img-consulta {
    display: none;
  }
}

@media screen and (max-width: 624px) {
  #titulo {
    font-size: 20px;
  }

  #subtitulo {
    font-size: 18px;
  }

  .grid-container {
    margin-bottom: 24px;
  }

  .terms-wrapper p {
    line-height: 2px;
    text-align: center;
    margin-top: 30px;
  }
}
</style>
